module.exports = __webpack_public_path__ + "static/media/footerTheme4.c1f79612.svg";